import { Box, Typography } from "@mui/material";
import { BoxProps } from "@mui/material/Box/Box";
import { mergeSx } from "src/utils/styles";

export interface FormSectionProps extends BoxProps {
	label: string;
	children: React.ReactNode;
}

export const FormSection = ({ label, children, sx, ...other }: FormSectionProps) => {
	return (
		<Box
			sx={mergeSx({
				gridColumn: "1 / -1",
				display: "inherit",
				gridTemplateColumns: "inherit",
				gap: "inherit",
				gridAutoRows: "it",
			}, sx)}
			{...other}
		>
			<Box
				sx={{
					gridColumn: "1 / -1",
					marginTop: "0.5rem",
					marginBottom: "1rem",
					display: "flex",
				}}
			>
				<Typography
					variant="h6"
					gutterBottom
					sx={{
						borderBottom: 2,
						borderColor: "primary.main",
						flex: 1
					}}
				>
					{label}
				</Typography>
			</Box>
			{children}
		</Box>
	);
};
